import PaintColor from './PaintColor';

export default class RecipePaintColor {
  constructor({ paintColor, percentage = 100, color = null }) {
    this.paintColor = paintColor;
    this.percentage = percentage;
    this.color = color;
  }

  toApi() {
    return {
      p: this.percentage,
      t: this.paintColor?.id,
      c: this.color,
    };
  }

  static fromApi(apiModel) {
    let paintColor = apiModel.paintColor || apiModel.t;
    if (paintColor != null) {
      if (typeof paintColor === 'object') {
        paintColor = PaintColor.fromApi(paintColor);
      } else {
        paintColor = PaintColor.fromID(paintColor);
      }
    }
    return new RecipePaintColor({
      percentage: apiModel.percentage || apiModel.p,
      paintColor,
      color: apiModel.color || apiModel.c,
    });
  }
}
